import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 20, color: '#F8FAFC', lineHeight: 1.7 }}>
      <h1 style={{ color: '#F7DE8A', marginBottom: 20 }}>Политика обработки персональных данных</h1>
      <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 20 }}>
        Дата последнего обновления: 13 сентября 2026 г.
      </p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>1. Общие положения</h2>
      <p>Настоящая Политика обработки персональных данных (далее — Политика) составлена в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению их безопасности, предпринимаемые оператором Khepri (далее — Оператор).</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>2. Какие данные мы собираем</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>ФИО, email, телефон</li>
        <li>Название компании, ИНН, ОГРН</li>
        <li>Данные о действиях на сайте (cookie, IP-адрес)</li>
        <li>Данные, которые вы вводите в систему (договоры, контрагенты, задачи)</li>
      </ul>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>3. Цели обработки</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>Предоставление доступа к сервису Khepri</li>
        <li>Улучшение работы сервиса</li>
        <li>Связь с вами по вопросам работы сервиса</li>
        <li>Анализ работы сайта (Яндекс.Метрика)</li>
      </ul>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>4. Где хранятся данные</h2>
      <p>Все персональные данные хранятся на серверах, расположенных на территории Российской Федерации. Передача данных за пределы РФ не осуществляется.</p>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>5. Передача данных третьим лицам</h2>
      <p>Мы используем следующие сервисы:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li><strong>Яндекс.Метрика</strong> — для анализа посещаемости (данные обезличены)</li>
        <li><strong>GigaChat (Сбер)</strong> — для работы ИИ-помощника (данные обрабатываются в РФ)</li>
      </ul>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>6. Ваши права</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>Получить информацию об обработке ваших данных</li>
        <li>Требовать уточнения, блокирования или уничтожения данных</li>
        <li>Отозвать согласие на обработку</li>
      </ul>

      <h2 style={{ color: '#F7DE8A', fontSize: 18, marginTop: 24 }}>7. Контакты</h2>
      <p>По вопросам обработки персональных данных: <a href="mailto:privacy@khepri.tech" style={{ color: '#F7DE8A' }}>privacy@khepri.tech</a></p>

      <p style={{ marginTop: 40, color: '#94A3B8', fontSize: 12 }}>
        © Khepri, 2026. Все права защищены.
      </p>
    </div>
  );
}

export default PrivacyPolicy;